import { NavRoute } from '../../shared/navigation/nav.route.interface';
import { SecurityEnum } from '../security/security.enum';

/***************************************************************************************************
 * Nixies Nav
 * All screens to do with data import and display should be shown here
 */
export const getNixiesNav: () => NavRoute = () => {
	return {
		name: 'Nixies',
		security: sec => sec?.securityAdministration?.viewSecurityReports === SecurityEnum.FullAccess,
		path: 'nixie-list',
	};
};
